import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { UrlConstantes } from "../utilerias/constantes/urlconstantes";
import {
  EstadoIncidenciaSeguridad,
  IncidenciaSeguridad,
  IncidenciaSeguridadComentario,
  IncidenciaSeguridadReq,
  IncidenciaSeguridadRes,
  IncidenciaSeguridadRevisionMensual,
} from "../shared/model/iso42001/incidencia-seguridad.model";

@Injectable({
  providedIn: "root",
})
export class IncidenciasSeguridadService {
  constructor(private http: HttpClient) {}

  consultarKanban(
    filtro: IncidenciaSeguridad,
    regInicial: number,
    regXPagina: number,
  ): Observable<IncidenciaSeguridadRes> {
    const req: IncidenciaSeguridadReq = { filtro, regInicial, regXPagina };
    return this.http.post<IncidenciaSeguridadRes>(
      UrlConstantes.ISO42001_INCIDENCIA_SEGURIDAD_CONSULTAR_KANBAN,
      req,
    );
  }

  obtener(idIncidenciaIa: number): Observable<IncidenciaSeguridadRes> {
    const req: IncidenciaSeguridadReq = { idIncidenciaIa };
    return this.http.post<IncidenciaSeguridadRes>(
      UrlConstantes.ISO42001_INCIDENCIA_SEGURIDAD_OBTENER,
      req,
    );
  }

  consultarResponsables(): Observable<IncidenciaSeguridadRes> {
    const req: IncidenciaSeguridadReq = {};
    return this.http.post<IncidenciaSeguridadRes>(
      UrlConstantes.ISO42001_INCIDENCIA_SEGURIDAD_RESPONSABLES,
      req,
    );
  }

  guardar(incidencia: IncidenciaSeguridad): Observable<IncidenciaSeguridadRes> {
    const req: IncidenciaSeguridadReq = { incidencia };
    return this.http.post<IncidenciaSeguridadRes>(
      UrlConstantes.ISO42001_INCIDENCIA_SEGURIDAD_GUARDAR,
      req,
    );
  }

  actualizar(incidencia: IncidenciaSeguridad): Observable<IncidenciaSeguridadRes> {
    const req: IncidenciaSeguridadReq = { incidencia };
    return this.http.post<IncidenciaSeguridadRes>(
      UrlConstantes.ISO42001_INCIDENCIA_SEGURIDAD_ACTUALIZAR,
      req,
    );
  }

  cambiarEstado(
    idIncidenciaIa: number,
    estadoEvento: EstadoIncidenciaSeguridad,
    incidencia?: IncidenciaSeguridad,
    comentario?: IncidenciaSeguridadComentario,
  ): Observable<IncidenciaSeguridadRes> {
    const req: IncidenciaSeguridadReq = { idIncidenciaIa, estadoEvento, incidencia, comentario };
    return this.http.post<IncidenciaSeguridadRes>(
      UrlConstantes.ISO42001_INCIDENCIA_SEGURIDAD_CAMBIAR_ESTADO,
      req,
    );
  }

  guardarComentario(comentario: IncidenciaSeguridadComentario): Observable<IncidenciaSeguridadRes> {
    const req: IncidenciaSeguridadReq = { comentario };
    return this.http.post<IncidenciaSeguridadRes>(
      UrlConstantes.ISO42001_INCIDENCIA_SEGURIDAD_GUARDAR_COMENTARIO,
      req,
    );
  }

  obtenerVentanaRevisionMensual(): Observable<IncidenciaSeguridadRes> {
    return this.http.post<IncidenciaSeguridadRes>(
      UrlConstantes.ISO42001_INCIDENCIA_SEGURIDAD_REVISION_VENTANA,
      {},
    );
  }

  guardarRevisionMensual(revisionMensual: IncidenciaSeguridadRevisionMensual): Observable<IncidenciaSeguridadRes> {
    const req: IncidenciaSeguridadReq = { revisionMensual };
    return this.http.post<IncidenciaSeguridadRes>(
      UrlConstantes.ISO42001_INCIDENCIA_SEGURIDAD_REVISION_GUARDAR,
      req,
    );
  }

  consultarRevisionMensual(mes?: number, anio?: number): Observable<IncidenciaSeguridadRes> {
    const req: IncidenciaSeguridadReq = { mes, anio };
    return this.http.post<IncidenciaSeguridadRes>(
      UrlConstantes.ISO42001_INCIDENCIA_SEGURIDAD_REVISION_CONSULTAR,
      req,
    );
  }
}
